import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { BASE_CLASSES } from './constants';

const Counter = ({ current, max, className }) => {
    const content = max ? `${current} / ${max}` : current;
    const classes = cn(BASE_CLASSES, className);

    return (
        <span className={classes}>
            {content}
        </span>
    );
};

Counter.propTypes = {
    current: PropTypes.number.isRequired,
    max: PropTypes.number,
    className: PropTypes.string
};

export default Counter;
